import React from 'react';

function ContactPage() {
  // États du formulaire
  // const [name, setName] = useState('');
  // const [email, setEmail] = useState('');
  // const [subject, setSubject] = useState('sav');  // Valeur par défaut : SAV
  // const [message, setMessage] = useState('');

  // Gestion de la soumission du formulaire
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   // Ici, vous pouvez traiter l’envoi des données (API, service backend etc.)
  //   console.log({
  //     name,
  //     email,
  //     subject,
  //     message
  //   });
    
  //   // Réinitialiser le formulaire, par exemple :
  //   setName('');
  //   setEmail('');
  //   setSubject('sav');
  //   setMessage('');
    
  //   alert('Merci pour votre message ! Notre équipe vous contactera prochainement.');
  // };

  // Styles inline de base (à adapter ou extraire dans un CSS)
  const containerStyle = {
    maxWidth: '600px',
    margin: '0 auto',
    padding: '2rem'
  };

  // const headingStyle = {
  //   fontSize: '1.5rem',
  //   marginBottom: '1rem'
  // };

  // const labelStyle = {
  //   display: 'block',
  //   marginBottom: '0.5rem',
  //   fontWeight: 'bold'
  // };

  // const inputStyle = {
  //   width: '100%',
  //   padding: '0.5rem',
  //   marginBottom: '1rem',
  //   borderRadius: '4px',
  //   border: '1px solid #ccc'
  // };

  // const selectStyle = {
  //   ...inputStyle,
  //   cursor: 'pointer'
  // };

  // const textAreaStyle = {
  //   ...inputStyle,
  //   minHeight: '100px'
  // };

  // const buttonStyle = {
  //   backgroundColor: '#4fb897',
  //   color: '#fff',
  //   padding: '0.5rem 1rem',
  //   border: 'none',
  //   borderRadius: '4px',
  //   cursor: 'pointer'
  // };

  const infoBoxStyle = {
    backgroundColor: '#f9f9f9',
    padding: '1rem',
    marginBottom: '2rem',
    borderRadius: '4px'
  };

  return (
    <div style={containerStyle}>
      <h1 style={{ marginBottom: '1rem' }}>Contact & SAV</h1>

      <div style={infoBoxStyle}>
        <p>
          Bienvenue sur la page de contact et de Service Après-Vente de <strong>Baltee Mobility</strong>. 
          Vous avez une question concernant l’un de nos produits (B01, etc.) ou vous souhaitez 
          bénéficier d’une assistance ?
        </p>
        <ul>
          <li>
            <strong>Service après-vente :</strong> <a href="mailto:sav@baltee.com">sav@baltee.com</a> (pour le suivi de commande, les pannes ou les réparations).
          </li>
          <br />
          <li>
            <strong>Contact général :</strong> <a href="mailto:contact@baltee.com">contact@baltee.com</a> (pour toute autre demande).
          </li>
          {/* <li>
            <strong>Par téléphone :</strong> +33&nbsp;7&nbsp;75&nbsp;77&nbsp;62&nbsp;43 (service 
            client ouvert du lundi au vendredi, de 9h à 18h).
          </li> */}
          {/* <li>
            <strong>Par formulaire :</strong> complétez le formulaire ci-dessous et notre équipe 
            vous répondra sous 48h.
          </li> */}
        </ul>
        <p>
          Merci de votre confiance envers Baltee Mobility. Nous mettons tout en œuvre pour vous 
          offrir la meilleure expérience possible avec nos solutions de mobilité.
        </p>
      </div>

      {/* Formulaire de contact / SAV */}
      {/* <h2 style={headingStyle}>Envoyer un message</h2>
      <form onSubmit={handleSubmit}>
        <label style={labelStyle} htmlFor="name">
          Nom :
        </label>
        <input
          id="name"
          type="text"
          placeholder="Votre nom complet"
          style={inputStyle}
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />

        <label style={labelStyle} htmlFor="email">
          E-mail :
        </label>
        <input
          id="email"
          type="email"
          placeholder="Votre adresse e-mail"
          style={inputStyle}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label style={labelStyle} htmlFor="subject">
          Motif :
        </label>
        <select
          id="subject"
          style={selectStyle}
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
        >
          <option value="sav">SAV (Assistance technique, panne, réparation)</option>
          <option value="general">Question générale / Renseignement</option>
          <option value="feedback">Feedback / Suggestions</option>
          <option value="autre">Autre</option>
        </select>

        <label style={labelStyle} htmlFor="message">
          Votre message :
        </label>
        <textarea
          id="message"
          placeholder="Décrivez votre demande en détail..."
          style={textAreaStyle}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
        />

        <button type="submit" style={buttonStyle}>
          Envoyer
        </button>
      </form> */}
    </div>
  );
}

export default ContactPage;
